import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a089f5fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pagination" }
const _hoisted_2 = { class: "pagination__header" }
const _hoisted_3 = { class: "pagination__total-products" }
const _hoisted_4 = { class: "select-group" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "select-group__header" }, "Product per page:", -1 /* HOISTED */))
const _hoisted_6 = {
  key: 0,
  class: "select-group__select--list"
}
const _hoisted_7 = ["onClick"]

import { usePagination } from '@/store';
import { useCart } from '@/store';
import { storeToRefs } from 'pinia';
import Paginate from 'vuejs-paginate-next';
import { maxLimit } from '@/store/cart/_constants';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CartPagination',
  setup(__props) {

const { totalProducts } = storeToRefs(useCart());
const { limit, page, totalPage } = storeToRefs(usePagination());
const isCollapsed = ref(true);
const MyPaginate = Paginate;

const changeOption = (option: number): void => {
  limit.value = option;
  isCollapsed.value = true;
};

const updateSelect = (): void => {
  isCollapsed.value = !isCollapsed.value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, [
      _createTextVNode(" Cart "),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(totalProducts)), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", {
        class: "select-group__select",
        tabindex: "0",
        onBlur: _cache[0] || (_cache[0] = ($event: any) => (isCollapsed.value = true))
      }, [
        _createElementVNode("div", {
          onClick: updateSelect,
          class: _normalizeClass(["select-group__select--limit", { 'select-opened': !isCollapsed.value }])
        }, [
          _createTextVNode(_toDisplayString(_unref(limit)) + " ", 1 /* TEXT */),
          _createElementVNode("i", {
            class: _normalizeClass(["icon-next", { 'next-opened': !isCollapsed.value }])
          }, null, 2 /* CLASS */)
        ], 2 /* CLASS */),
        (!isCollapsed.value)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(maxLimit), (option) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "select-group__select--option",
                  onClick: ($event: any) => (changeOption(option)),
                  key: option
                }, _toDisplayString(option), 9 /* TEXT, PROPS */, _hoisted_7))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true)
      ], 32 /* HYDRATE_EVENTS */)
    ]),
    _createVNode(_unref(MyPaginate), {
      modelValue: _unref(page),
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-count": _unref(totalPage),
      "prev-text": '<',
      "next-text": '>',
      "container-class": 'pages',
      "page-class": 'page',
      "next-class": 'page arrow',
      "prev-class": 'page arrow',
      "break-view-class": 'break'
    }, null, 8 /* PROPS */, ["modelValue", "page-count"])
  ]))
}
}

})